import { render, staticRenderFns } from "./OsInputRadioGroup.vue?vue&type=template&id=69262fe8&scoped=true"
import script from "./OsInputRadioGroup.vue?vue&type=script&lang=ts"
export * from "./OsInputRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./OsInputRadioGroup.vue?vue&type=style&index=0&id=69262fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69262fe8",
  null
  
)

export default component.exports